import React from "react";
import LiveTradingCenterDock from "./LiveTradingCenterDock";
import {
  TRADING_MODE_IDS,
  TRADING_MODE_ORDER,
  canSelectTradingMode,
  getTradingModePolicy,
} from "./tradingModes";
import "./TradingCenter.css";

function TradingCenterControls({ policy, onModeChange, featureAccess }) {
  const compactSafetyLabel =
    policy.id === TRADING_MODE_IDS.PAPER
      ? "PAPER ONLY"
      : policy.id === TRADING_MODE_IDS.PAPER_AUTO
      ? "PAPER AUTO ONLY"
      : policy.id === TRADING_MODE_IDS.AUTO_LIVE
      ? "LOCKED"
      : "EXECUTION GATED";

  return (
    <section
      className="tradingCenterCompact"
      aria-label="Trading Center mode control"
      aria-describedby="trading-center-safety-policy"
      title={policy.safetyMessage}
    >
      <div
        className="tradingCenterCompactIdentity"
        aria-label="Current trading mode"
      >
        <span>TRADING CENTER</span>
        <strong>{policy.label}</strong>
        <small>{compactSafetyLabel}</small>
      </div>

      <div className="tradingCenterModeStack">
        <div className="tradingCenterModeFamilies" aria-hidden="true">
          <strong>REGULAR TRADE</strong>
          <strong>AUTO TRADE</strong>
        </div>

        <nav
          className="tradingCenterModeSelector"
          aria-label="Trading mode"
        >
          {TRADING_MODE_ORDER.map((modeId) => {
            const modePolicy = getTradingModePolicy(modeId);
            const selected = modePolicy.id === policy.id;
            const selectable = canSelectTradingMode(modeId, featureAccess);

            return (
              <button
                key={modePolicy.id}
                type="button"
                className={selected ? "active" : ""}
                aria-pressed={selected}
                aria-disabled={!selectable}
                disabled={!selectable}
                onClick={() =>
                  selectable && onModeChange(modePolicy.id)
                }
              >
                <span>{modePolicy.label}</span>
                {modePolicy.locked ? <small>LOCKED</small> : null}
              </button>
            );
          })}
        </nav>
      </div>

      <span
        id="trading-center-safety-policy"
        className="visuallyHidden"
      >
        {policy.safetyMessage}
      </span>
    </section>
  );
}

function TradingCenter({
  mode,
  onModeChange,
  renderMode,
  renderReadOnlyLive,
  featureAccess,
}) {
  const policy = getTradingModePolicy(mode);

  const controls = (
    <TradingCenterControls
      policy={policy}
      featureAccess={featureAccess}
      onModeChange={onModeChange}
    />
  );

  const currentModeSelectable = canSelectTradingMode(
    policy.id,
    featureAccess,
  );

  const dockControlsInLiveWorkspace =
    policy.id === TRADING_MODE_IDS.LIVE && currentModeSelectable;

  return (
    <section
      className="tradingCenter"
      aria-label="Trading Center"
      data-trading-mode={policy.id}
      data-execution-environment={policy.executionEnvironment}
    >
      {!dockControlsInLiveWorkspace && (
        <div className="tradingCenterStandaloneControls">
          {controls}
        </div>
      )}

      <div className="tradingCenterModeWorkspace">
        {currentModeSelectable && typeof renderMode === "function"
          ? renderMode(policy)
          : policy.id === TRADING_MODE_IDS.LIVE &&
            typeof renderReadOnlyLive === "function"
          ? renderReadOnlyLive(policy)
          : null}
      </div>

      {dockControlsInLiveWorkspace && (
        <LiveTradingCenterDock>
          {controls}
        </LiveTradingCenterDock>
      )}
    </section>
  );
}

export { TradingCenterControls };
export default TradingCenter;
